import { Payment } from '@linktivity/link-payment';
import config from '../config';

const paymentApi = new Payment.PaymentApi(config);

export default paymentApi;
